<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <div class="margin-top-30 hidden-lg hidden-xl hidden-md"></div>

                    <div v-if="$root.user.tipo == 'admin'">
                        <div class="dashboard-headline hidden-xs hidden-sm">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                Painel do Administrador
                            </h3>
                        </div>
                        <div class="dashboard-headline hidden-lg hidden-xl hidden-md center">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                Painel do Administrador
                            </h3>
                        </div>
                    </div>

                    <div class="row" v-if="$root.user.tipo == 'admin'">
                        <div class="col-xs-12">
                            <p>
                                <i class="las la-share"></i> Atalhos
                            </p>
                        </div>
                        <div class="col-xs-12 col-lg-12" style="text-align: center;">
                            <router-link :to="{'name': 'CadastrarAgendamentos', 'query': {'t': (new Date().getTime())}}" tag="button" class="button button-large color-green margin-right-10 margin-bottom-10 block-mobile" data-tooltip="Agende visitas avulsas para clientes">
                                <i class="las la-plus"></i>
                                Agendar visita
                            </router-link>
                            <router-link :to="{'name': 'CadastrarPlanejamentos', 'query': {'t': (new Date().getTime())}}" tag="button" class="button button-large color-green margin-right-10 margin-bottom-10 block-mobile" data-tooltip="Cadastro de planejamento de visitas">
                                <i class="las la-plus"></i>
                                Cadastrar planejamento
                            </router-link>     
                            <router-link :to="{'name': 'CadastrarContratos', 'query': {'t': (new Date().getTime())}}" tag="button" class="button button-large color-green margin-right-10 margin-bottom-10 block-mobile" data-tooltip="Cadastre um contrato para determinado cliente">
                                <i class="las la-plus"></i>
                                Cadastrar contrato
                            </router-link>
                            <router-link :to="{'name': 'CadastrarClientes', 'query': {'t': (new Date().getTime())}}" tag="button" class="button button-large color-green margin-right-10 margin-bottom-10 block-mobile" data-tooltip="Cadastre um cliente rapidamente">
                                <i class="las la-plus"></i>
                                Cadastrar cliente
                            </router-link>                                 
                        </div>
                        <div class="col-xs-12 margin-top-20">
                            <p>
                                <i class="las la-info-circle"></i> Visão geral
                            </p>
                        </div>                        
                        <div class="col-xs-12 col-lg-12">
                            <div class="row">
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-check-circle"></i> {{metricas.visitasCompletas}}
                                        </h2>
                                        <p>
                                            Visitas
                                            <br>
                                            completas
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-times-circle"></i> {{metricas.visitasIncompletas}}
                                        </h2>
                                        <p>
                                            Visitas
                                            <br>
                                            incompletas
                                        </p>
                                    </div>
                                </div>                        
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-exclamation-triangle"></i> {{metricas.visitasPerdidas}}
                                        </h2>
                                        <p>
                                            Visitas
                                            <br>
                                            perdidas
                                        </p>
                                    </div>
                                </div>                          
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-history"></i> {{metricas.visitasAtrasadas}}
                                        </h2>
                                        <p>
                                            Visitas
                                            <br>
                                            atrasadas
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-clock"></i> {{metricas.visitasDuracaoMedia}}
                                        </h2>
                                        <p>
                                            Duração média
                                            <br>
                                            da visita (horas)
                                        </p>
                                    </div>
                                </div>                            
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-stopwatch"></i> {{metricas.visitasDuracaoMenor}}
                                        </h2>
                                        <p>
                                            Menor
                                            <br>
                                            duração (horas)
                                        </p>
                                    </div>
                                </div>                        
                                <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4 margin-bottom-15">
                                    <div class="card widget-card">
                                        <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                            <i class="las la-hourglass"></i> {{metricas.visitasDuracaoMaior}}
                                        </h2>
                                        <p>
                                            Maior
                                            <br>
                                            duração (horas)
                                        </p>
                                    </div>
                                </div> 
                            </div>
                        </div>                                                 
                    </div>


                    <div v-if="$root.user.tipo == 'prestador'">
                        <div class="dashboard-headline hidden-xs hidden-sm">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                Painel do técnico
                            </h3>
                        </div>
                        <div class="dashboard-headline hidden-lg hidden-xl hidden-md center">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                Painel do técnico
                            </h3>
                        </div>
                    </div>

                    <div class="row" v-if="$root.user.tipo == 'prestador'">
                        <div class="col-xs-12 margin-bottom-20">
                            <button v-on:click="$root.go('CadastrarAgendamentos', JSON.stringify({'t': (new Date().getTime())}))" type="button" class="button button-large green">
                                <i class="las la-plus"></i>
                                Agendar visita
                            </button>
                        </div>
                        <div class="col-xs-12">
                            <p>
                                <i class="las la-info-circle"></i> Visão geral
                            </p>
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                            <div class="card widget-card">
                                <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                    <i class="las la-exclamation-triangle"></i>
                                    {{metricas.visitasPendentes}}
                                </h2>
                                <p>
                                    Agendamentos
                                    <br>
                                    pendentes
                                </p>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                            <div class="card widget-card">
                                <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                    <i class="las la-clipboard-check"></i>
                                    {{metricas.visitasCompletas}}
                                </h2>
                                <p>
                                    Visitas
                                    <br>
                                    realizadas
                                </p>
                            </div>
                        </div>                        
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 margin-bottom-15">
                            <div class="card widget-card">
                                <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                    <i class="las la-exclamation-circle"></i>
                                    {{metricas.visitasHoje}}
                                </h2>
                                <p>
                                    Agendamentos
                                    <br>
                                    para hoje
                                </p>
                            </div>
                        </div>                                                      
                    </div>

                    <div v-if="$root.user.tipo == 'contratante'">
                        <div class="dashboard-headline hidden-xs hidden-sm margin-bottom-30" style="flex-direction: column; align-items: flex-start;">
                            <h3>
                                <i class="las la-briefcase"></i>
                                Cliente Hidrobombas
                            </h3>
                            <h4 style="width: 100%; display: block;">
                                {{$root.user.empresa ? $root.user.empresa : $root.user.nome}}
                            </h4>
                        </div>
                        <div class="dashboard-headline hidden-lg margin-bottom-30 hidden-xl hidden-md center" style="flex-direction: column;">
                            <h3>
                                <i class="las la-briefcase"></i>
                                Cliente Hidrobombas
                            </h3>
                            <h4 style="width: 100%; display: block;">
                                {{$root.user.empresa ? $root.user.empresa : $root.user.nome}}
                            </h4>
                        </div>
                    </div>

                    <div class="row" v-if="$root.user.tipo == 'contratante'">
                        <div class="col-xs-12">
                            <p>
                                <i class="las la-info-circle"></i> Visão geral
                            </p>
                        </div>
                        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6 col-xl-3 margin-bottom-15">
                            <div class="card widget-card">
                                <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                    <i class="las la-exclamation-triangle"></i>
                                    {{metricas.visitasPendentes}}
                                </h2>
                                <p>
                                    Visitas
                                    <br>
                                    pendentes
                                    <button v-on:click="$root.go('Visitas')" type="button" class="button color-secondary ">
                                        <i class="las la-list"></i>
                                        Visualizar
                                    </button>                                          
                                </p>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6 col-xl-3 margin-bottom-15">
                            <div class="card widget-card">
                                <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                    <i class="las la-clipboard-check"></i>
                                    {{metricas.visitasCompletas}}
                                </h2>
                                <p>
                                    Visitas
                                    <br>
                                    realizadas
                                    <button v-on:click="$root.go('OrdensServicos')" type="button" class="button color-secondary ">
                                        <i class="las la-list"></i>
                                        Visualizar
                                    </button>                                    
                                </p>
                            </div>
                        </div>                        
                        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6 col-xl-4 margin-bottom-15">
                            <div class="card widget-card">
                                <h2 style="font-size: 40px; font-weight: bold; margin-top: 5px;">
                                    <i class="las la-exclamation-circle"></i>
                                    R$ {{metricas.faturasPendentes | toMoney}}

                                </h2>
                                <p style="width: 100%;">
                                    Faturas
                                    <br>
                                    pendentes

                                    <button v-on:click="$root.go('Faturas')" type="button" class="button color-orange ">
                                        <i class="las la-eye"></i>
                                        Visualizar faturas
                                    </button>

                                </p>
                            </div>
                        </div>                                                      
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Dashboard',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },          
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "loading": {
                "submit":           false
            },

            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "dataInicio":       "",
                "dataFinal":        ""
            },
            "metricas":         {
                "visitasCompletas":         0,
                "visitasIncompletas":       0,
                "visitasPerdidas":          0,
                "visitasAtrasadas":         0,
                "visitasDuracaoMedia":      0,
                "visitasDuracaoMaior":      0,
                "visitasDuracaoMenor":      0,
                "faturasPendentes":         0
                
            }                       
        }
    },  
    methods: {     
        getMetricas: function() {
            var self        = this;
            console.log("getMetricas()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/metricas.php", {params: self.form})
                .then(response => {
                    
                    console.log("getMetricas() response", response);    
                    self.metricas               = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    loading.hide();
                    console.log("getMetricas() error", error);                    
                    reject(error);
                });   
            });   
        },  
        init: function() {
            console.log("init()");
            var self = this;
            loading.show();
            Promise.all([
                self.getMetricas(),
            ]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            });               
        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.init();
    },
    activated: function() {
        var self = this;
    
        

    },    

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .widget-card .button {
        float: right; 
        position: absolute; 
        right: 20px; 
        bottom: 15px; 
        top: auto;
        padding: 5px 15px !important;
    }

    .fun-fact-text {
        margin: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue